module.exports = __webpack_public_path__ + "static/img/login-default.39721a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login-default.jpg
// module id = KLtT
// module chunks = 25